import React from 'react';
import KingsPath_00 from '../images/kingspath/mockup.png';
import Footer from '../components/Footer';
import GamePage from '../components/GamePage';

function KingsPath() {
  return (
    <>
      <GamePage
        name="King's Path"
        description="The Balloonist is a casual puzzle game. Your goal is to help Willy and his pet
        Birdy collecting balloons so they can keep their trip around world."
        images={[KingsPath_00]}
        conclusion="Mostly developed using C# and Unity Game Engine this is an unreleased 
        personal project aka my first stand alone game"
      />
      <Footer />
    </>
  );
}

export default KingsPath;
